import { useMutation } from '@tanstack/react-query'
import { useApi } from '../store/auth.store'

export interface ForgotPasswordResult {
  success: boolean
  message: string
  devResetUrl?: string
}

export interface ResetPasswordResult {
  success: boolean
  message: string
}

export function useForgotPassword() {
  const api = useApi()
  return useMutation<ForgotPasswordResult, Error, string>({
    mutationFn: (email: string) => api.post('/auth/forgot-password', { email }),
  })
}

export function useResetPassword() {
  const api = useApi()
  return useMutation<ResetPasswordResult, Error, { token: string; newPassword: string }>({
    mutationFn: ({ token, newPassword }) => api.post('/auth/reset-password', { token, newPassword }),
  })
}
